import { IVariantArticles, ITeamDesignerVariantArticles, IVariant, IBasketItems } from './article';
import { IContext } from '../types';
import { request, logHttpError } from './../../helpers';

export class BasketService {
    private static _instance: BasketService;
    private context: IContext;

    public constructor() {
        this.context = window.__PP_LC_CONTEXT__;
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public getArticles(): Promise<IBasketItems | undefined> {
        const apiUrl = this.context.baseUrl
            + 'api/basket/FastlaneProcessing/articles';

        return request<IBasketItems>(apiUrl)
            .catch(logHttpError);
    }

    public postArticles(smakeVariantId: number, variants: Array<IVariant>): Promise<any> {
        const body: IVariantArticles = {
            smakeVariantId: smakeVariantId,
            variants
        };

        const apiUrl = this.context.baseUrl
            + 'api/basket/FastlaneProcessing/articles';

        return request(apiUrl, {
            method: 'POST',
            body: JSON.stringify(body),
        })
            .catch(logHttpError);
    }

    public postArticlesForTeamDesigner(variants: Array<ITeamDesignerVariantArticles>): Promise<any> {
        const body = { teamVariants: variants };

        const apiUrl = this.context.baseUrl
            + 'api/basket/MyDesign';

        return request(apiUrl, {
            method: 'POST',
            body: JSON.stringify(body),
        })
            .catch(logHttpError);
    }

    public callSimplePersonalize(basketItemId: string) {
        if (window)
            window.shell.publishTo('ESSA.BasketPage.OpenSimplePersonalizationModal', { basketItemGuid: basketItemId });
    }
}